"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasBuffer = exports.alphabet = void 0;
exports.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
exports.hasBuffer = typeof Buffer === 'function' && typeof Buffer.from === 'function';
